export function normalizeDesignPayload(design = {}, fallback = {}) {
  const resolved = {
    presetKey: design.presetKey ?? fallback.presetKey,
    outerBg: design.outerBg ?? fallback.outerBg,
    cardBg: design.cardBg ?? fallback.cardBg,
    textColor: design.textColor ?? fallback.textColor,
    accentColor: design.accentColor ?? fallback.accentColor,
    headerBg:
      design.header?.bg ??
      design.headerBg ??
      fallback.headerBg,
    headerTextColor:
      design.header?.textColor ??
      design.headerTextColor ??
      fallback.headerTextColor,
    headerButtonColor:
      design.header?.buttonColor ??
      design.headerButtonColor ??
      fallback.headerButtonColor,
    headerButtonText:
      design.header?.buttonText ??
      design.headerButtonText ??
      fallback.headerButtonText,
    fontFamily: design.fontFamily ?? fallback.fontFamily,
    fontSize: design.fontSize ?? fallback.fontSize ?? "16px",
    contentWidth: design.contentWidth ?? fallback.contentWidth,
    header: {
      ...(fallback.header || {}),
      ...(design.header || {}),
    },
    footerDefaults: {
      ...(fallback.footerDefaults || {}),
      ...(design.footerDefaults || {}),
    },
  };

  resolved.header = {
    ...resolved.header,
    bg: resolved.header.bg ?? resolved.headerBg,
    textColor: resolved.header.textColor ?? resolved.headerTextColor,
    buttonColor: resolved.header.buttonColor ?? resolved.headerButtonColor,
    buttonText: resolved.header.buttonText ?? resolved.headerButtonText,
  };

  return resolved;
}

export function denormalizeDesignPayload(design = {}) {
  return {
    presetKey: design.presetKey,
    outerBg: design.outerBg,
    cardBg: design.cardBg,
    textColor: design.textColor,
    accentColor: design.accentColor,
    headerBg: design.headerBg,
    headerTextColor: design.headerTextColor,
    headerButtonColor: design.headerButtonColor,
    headerButtonText: design.headerButtonText,
    fontFamily: design.fontFamily,
    fontSize: design.fontSize,
    contentWidth: design.contentWidth,
    header: design.header,
    footerDefaults: design.footerDefaults,
  };
}
